import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';

import { MatTabsModule } from '@angular/material/tabs';

import { MediaIfDirective } from '@exl-ng/mulo-core';
import {
    AvatarComponent,
    ExpandableComponent,
    FloatingToolbarButtonsComponent,
    FloatingToolbarComponent,
    FloatingToolbarSeparatorComponent,
    HtmlSanitizePipe,
    LoadingSlateComponent,
    PagingComponent,
    PrologueComponent,
    SearchbarAdvRootDirective,
    SearchbarAutocompleteTemplateDirective,
    SearchbarComponent,
    SearchbarOptionsComponent,
    SeparatorComponent,
    StatusTagComponent,
    StickyDirective,
    ToggleButtonComponent,
} from '@exl-ng/mulo-common';
import {
    BriefComponent,
    CenteredBlockLayoutComponent,
    FacetItemComponent,
    FacetItemContentDirective,
    FacetNumericalComponent,
    FacetsActiveComponent,
    FacetsComponent,
    FacetSectionComponent,
    FacetSortComponent,
    SideMainLayoutComponent,
} from '@exl-ng/mulo-views';

import { CitationsModule } from '../parts/citations/citations.module';
import { LayoutsModule } from '../parts/layouts/layouts.module';

import { TagsModule } from '../parts/tags/tags.module';
import { SharedModule } from '../shared/shared.module';
import { AdvancedSearchModule } from '../parts/advanced-search/advanced-search.module';

import { DiscoveryComponent } from './discovery.component';
import { DiscoveryRoutingModule } from './discovery-routing.module';
import { DiscoveryResultsComponent } from './discovery-results/discovery-results.component';
import { DiscoveryResultsInfoComponent } from './discovery-results-info/discovery-results-info.component';
import { DiscoveryStandaloneComponent } from './discovery-standalone/discovery-standalone.component';
import { DiscoveryToolbarModule } from './discovery-toolbar/discovery-toolbar.module';
import { ResearchUnitsModule } from '../research-units/research-units.module';

@NgModule({
    imports: [
    SharedModule,
    DiscoveryRoutingModule,
    LayoutsModule,
    PrologueComponent,
    ToggleButtonComponent,
    AvatarComponent,
    TagsModule,
    NgxPaginationModule,
    PagingComponent,
    DiscoveryToolbarModule,
    LoadingSlateComponent,
    FloatingToolbarComponent,
    FloatingToolbarButtonsComponent,
    FloatingToolbarSeparatorComponent,
    CitationsModule,
    ExpandableComponent,
    SeparatorComponent,
    StatusTagComponent,
    FacetsComponent,
    FacetItemComponent,
    FacetItemContentDirective,
    FacetSectionComponent,
    FacetsActiveComponent,
    FacetSortComponent,
    FacetNumericalComponent,
    MediaIfDirective,
    CenteredBlockLayoutComponent,
    SideMainLayoutComponent,
    StickyDirective,
    SearchbarComponent,
    SearchbarOptionsComponent,
    SearchbarAutocompleteTemplateDirective,
    SearchbarAdvRootDirective,
    AdvancedSearchModule,
    MatTabsModule,
    BriefComponent,
    ResearchUnitsModule,
    HtmlSanitizePipe,
    DiscoveryStandaloneComponent,
    DiscoveryComponent,
    DiscoveryResultsComponent,
    DiscoveryResultsInfoComponent,
],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DiscoveryModule {}
